import React from 'react'

import InstructorNavbar from '../components/instructor/InstructorNavbar';
import Header from '../components/Header/Header'
import TarjumaCard from '../components/Cards/TarjumaCard';

const tarjumaPage = () => {
    return (

        <>
        <InstructorNavbar/>
        <Header/>
        <TarjumaCard/>
        
        </>
      );
}
 
export default tarjumaPage;